import { Tooltip } from "@mui/material";
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ToggleFab from "../ToggleFab";
import useCanvasRulersTool from "@src/v3.0.0/store/canvas-rulers";
import { useEffect, useRef } from "react";
export default function CanvasRulersTool() {
  const {shown, setShown} = useCanvasRulersTool();
  const button = useRef();

  useEffect(() => {
    setTimeout(() => {
      // button.current.click();
      // console.log(button.current);
    }, 1000);
  }, []);

  return null;
  return (
    <Tooltip title="Mostra i teli" placement="top">
      <ToggleFab
        active={shown}
        ref={button}
        onClick={() => setShown(!shown)}
      >
        <SquareFootIcon fontSize="1.4em" />
      </ToggleFab>
    </Tooltip>
  )
}